import React, { createRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useReactToPrint } from 'react-to-print'

import PrintableTicket from '../../components/transpais/TranspaisPrintableTicket'

import { TicketType } from '../../utilities/constants'

import styles from './AdminTicket.module.scss'
import { useAtom } from 'jotai'
import { idleDoneTimerPaused } from '../../utilities/atoms'
import { useLogger } from '../../contexts/logger.context'
import { currency } from '../../components/transpais/helpers/currency'
import { PassengerType, TicketService } from '../../components/transpais/enums'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const TranspaisTicket = forwardRef(({
                                 ticket,
                                 redondo,
                                 regreso,
                                 tripData,
                                 payment,
                                 confirmation,
                                 printable,
                                 ask,
                                 done,
                                 onClick
                               }, ref) => {

  const printableRef = createRef()
  //const isPrinting = false//useDetectPrint()
  const {loggerDebug, loggerError} = useLogger()

  const [, setIdleDonePaused] = useAtom(idleDoneTimerPaused)
  const [printed, setPrinted] = useState(false)
  //const [selected, setSelected] = useState(false)
  const handlePrint = useReactToPrint({
    content: () => {
      loggerDebug('Content', printableRef, printableRef.current)
      return printableRef.current
    }, onBeforePrint: () => {
      setIdleDonePaused(true)
    }, //removeAfterPrint: false,
    onAfterPrint: () => {
      //setIdlePaused(false)
      setIdleDonePaused(false)
      setPrinted(true)
      done()
    }, onPrintError: (errorLocation, error) => {
      loggerError(errorLocation, error)
      setIdleDonePaused(false)
    }
  })

  useImperativeHandle(ref, () => ({
    printTicket() {
      handlePrint()
    }
  }))

  const printTicket = () => {
    //loggerDebug('Printed', printed)
    //setIdlePaused(true)
    if (printed) {
      loggerDebug('Printed', 'ask')
      ask()
    } else {
      setPrinted(true)
      handlePrint()
    }
  }

  return (<div ref={ ref }>
    <div
      className={ [styles.ticket].join(' ') }
      onClick={ () => !printable ? onClick(ticket) : null } style={ {display: 'none'} }>
      <div className={ [styles.info, printable ? styles.small : null].join(' ') }>
        <div className={ styles.seat }>
          <h3>Asiento</h3>
          <p>{ ticket.seat ?? ticket.asiento }</p>
        </div>
        <div className={ styles.data }>
          <p className={ styles.name }>{ ticket ? ticket.pasajero : '-' }</p>
          { !printable && (<p className={ styles.type }>
            <svg className={ [styles.category, styles.icon].join(' ') }>
              <use xlinkHref={ `#${ TicketType.icon(ticket.tipo) }` }/>
            </svg>
            <span>{ TicketType.label(ticket.tipo) }</span>
            { redondo && <span className={ [styles.tag, regreso ? styles.return : null].join(' ') }>
              { tripData?.origin } › { tripData?.destination }
            </span> }
            { ticket.servicios.length > 0 ? ticket.servicios.map((servicio) => (
              <span key={ `t_${ ticket.id }_${ servicio.id }` } className={ styles.servicio }><FontAwesomeIcon
                icon={ TicketService.icon(servicio.nombre) }
                className={ styles.icon }/> <span>{ servicio.nombre }</span> <span>{ currency(servicio.precio) }</span></span>
            )) : null }
          </p>) }
        </div>
      </div>
      { !printable ? (<div className={ styles.precio }>
        <p>{ currency(ticket ? ticket.precio : 0) }</p>
        {/*<div className={ styles.selectWrapper }>*/ }
        {/*  <h3>Pagar</h3>*/ }
        {/*  <svg className={ [styles.icon].join(' ') }>*/ }
        {/*    <use xlinkHref={ `#${ !ticket.selected ? 'circle-dashed' : 'circle-check' }` }/>*/ }
        {/*  </svg>*/ }
        {/*</div>*/ }
      </div>) : (<div className={ styles.print } onClick={ printTicket }>
        <svg className={ [styles.icon, printed ? styles.done : null].join(' ') }>
          <use xlinkHref={ `#${ !printed ? 'print' : 'check' }` }/>
        </svg>
        <span>Imprimir</span>
      </div>) }
    </div>
    { printable && (
      <div>
        <PrintableTicket
          ref={printableRef}
          ticket={{
            ...(ticket && ticket.summary && Array.isArray(ticket.summary) && ticket.summary[0] ? ticket.summary[0] : {}),
            beestudio: ticket?.beestudio || {},
            transactionNumber: ticket?.transactionId || '',
          }}
          payment={payment}
          confirmation={confirmation}
        />
      </div>
    ) }
  </div>)
})

export default TranspaisTicket
